import React from 'react';
import { VIEW_SERVICE_REQUEST_LABELS as L } from '../../constants/labels';
import type { ViewServiceRequestDetail } from '../../types/viewServiceRequestType';
import { orDash } from './viewServiceRequestHelpers';
import { InfoField, SectionCard } from './viewServiceRequestUI';

interface SRFacilityTabProps {
  detail: ViewServiceRequestDetail | undefined;
}

const SRFacilityTab: React.FC<SRFacilityTabProps> = ({ detail }) => {
  return (
    <div className="flex flex-col gap-6">
      <SectionCard
        title={L.SECTION_FACILITY_DATA}
        testId="view-sr-section-facility-data"
      >
        <div
          className="grid gap-x-8 gap-y-6"
          style={{ gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)' }}
        >
          <InfoField
            label={L.FIELD_FACILITY_NAME}
            value={orDash(detail?.facility_name)}
            testId="view-sr-field-facility-name"
          />
          <InfoField
            label={L.FIELD_FACILITY_ID}
            value={orDash(detail?.facility_id)}
            testId="view-sr-field-facility-id"
          />
        </div>
      </SectionCard>

      <SectionCard
        title={L.SECTION_ADDRESS_DATA}
        testId="view-sr-section-address-data"
      >
        <div
          className="grid gap-x-8 gap-y-6"
          style={{ gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)' }}
        >
          <InfoField
            label={L.FIELD_ADDRESS1}
            value={orDash(detail?.facility_address_line1)}
            testId="view-sr-field-address1"
          />
          <InfoField
            label={L.FIELD_ADDRESS2}
            value={orDash(detail?.facility_address_line2)}
            testId="view-sr-field-address2"
          />
          <InfoField
            label={L.FIELD_CITY}
            value={orDash(detail?.facility_city)}
            testId="view-sr-field-city"
          />
          <InfoField
            label={L.FIELD_STATE}
            value={orDash(detail?.facility_state)}
            testId="view-sr-field-state"
          />
          <InfoField
            label={L.FIELD_ZIP}
            value={orDash(detail?.facility_postal_code)}
            testId="view-sr-field-zip"
          />
          <InfoField
            label={L.FIELD_COUNTRY}
            value={orDash(detail?.facility_country)}
            testId="view-sr-field-country"
          />
        </div>
      </SectionCard>
    </div>
  );
};

export default SRFacilityTab;
